import React, { useState } from 'react';
import { debounce } from 'lodash/fp';
import request from 'utils/request_ajax';
import QuestionPrompt from 'components/Practice/Learner/QuestionPrompt';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt';
import ReplyContainer from 'components/Practice/Learner/ReplyContainer';
import HighFiveShareableLink from 'components/shared/HighFiveShareableLink';
import EmailComposition from './EmailComposition';

const EmailPracticeQuestion = props => {
  const { data, meta, i18n } = props;

  const [emailReplyAnswerPresent, setEmailReplyAnswerPresent] = useState(
    !!data.givenAnswer,
  );
  const [emailCompositionAnswerPresent, setEmailCompositionAnswerPresent] =
    useState(
      !!data.givenAnswer &&
        (!!data.givenAnswer.subject || !!data.givenAnswer.body),
    );

  const isDisabled = meta.previewing || meta.finished;
  const isEmailComposition = data.questionType === 'email_composition';
  const isEmailReply = data.questionType === 'email_reply';

  const saveAnswer = (answerEntry, stringify) => {
    const answer = stringify ? JSON.stringify(answerEntry) : answerEntry;
    const answerData = { answer, question_id: data.questionId };
    const emailCompositionInputDeleted =
      stringify &&
      Object.keys(answerEntry.subject).length === 0 &&
      Object.keys(answerEntry.body).length === 0;
    request.postJSON(meta.saveUrl, answerData).then(() => {
      setEmailReplyAnswerPresent(!!answerEntry);
      setEmailCompositionAnswerPresent(!emailCompositionInputDeleted);
    });
  };

  return (
    <div className="bdrs-base PracticeQuestion">
      <QuestionElementPrompt
        required={data.required}
        subject={data.subject}
        questionSubjectClass={meta.questionSubjectClass}
        labelErrorClass={meta.labelErrorClass}
        isGradable={data.isGradable}
        elementHeaderClass={meta.elementHeaderClass}
        isPractice={data.isPractice}
      />
      {meta?.features?.practice && data.criteria.length > 0 && (
        <QuestionPrompt criteria={data.criteria} features={meta.features} />
      )}
      <div className="p-32 pt-16">
        {isEmailComposition && (
          <>
            <EmailComposition
              i18n={i18n}
              isDisabled={isDisabled}
              previewing={meta.previewing}
              givenAnswer={data.givenAnswer}
              saveAnswer={debounce(300, saveAnswer)}
            />
            <HighFiveShareableLink
              questionId={data.questionId}
              progressId={data.progressId}
              hasAnswerBeenSubmitted={emailCompositionAnswerPresent}
              isGradable={data.isGradable}
            />
          </>
        )}
        {isEmailReply && (
          <>
            <ReplyContainer
              timeStamp={i18n.email_reply.time_stamp}
              placeholder={i18n.email_reply.reply_placeholder}
              headerText={i18n.new_email_from}
              data={data.questionEmailData}
              questionType={data.questionType}
              isDisabled={isDisabled}
              previewing={meta.previewing}
              givenAnswer={data.givenAnswer}
              updateMessage={debounce(300, saveAnswer)}
            />
            <HighFiveShareableLink
              questionId={data.questionId}
              progressId={data.progressId}
              hasAnswerBeenSubmitted={emailReplyAnswerPresent}
              isGradable={data.isGradable}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default EmailPracticeQuestion;
